import { PageLoader } from '../../../Page'
import { useEmailProfileContext } from '../../Email.hooks'

function EmailProfileLoader() {
  const { isInitiated, isLoading, isPerformingAction } =
    useEmailProfileContext()

  return (isLoading || isPerformingAction) && isInitiated ? (
    <PageLoader />
  ) : null
}

export default EmailProfileLoader
